import { DatePipe } from "@angular/common";
import { AppConsts } from "@shared/AppConsts";
import { CharCaseHelper } from "@shared/helpers/CharCaseHelper";
import { CantonSpecificsServiceProxy, HealthRegisterLabelDto } from "@shared/service-proxies/service-proxies";
import { LocalizationService } from "abp-ng2-module";

export abstract class HealthRegisterBaseService {

    lSource: string = AppConsts.localization.defaultLocalizationSourceName;
    cantonId: string;

    constructor(
        protected datePipe: DatePipe,
        protected localization: LocalizationService,
        protected cantonSpecificsServiceProxy: CantonSpecificsServiceProxy,
    ) {

        this.cantonSpecificsServiceProxy.get().subscribe(result => {
            this.cantonId = result.cantonSpecifics.cantonId;
        });
    }


    resolveLanguage(label: HealthRegisterLabelDto): string {
        if (label == null) {
            return '-';
        }
        const currentLanguage = this.localization.currentLanguage;
        switch (currentLanguage.name) {
            case 'de-CH':
                return CharCaseHelper.capitalizeFirstLetter(label.labelDe);
            case 'fr-CH':
                return CharCaseHelper.capitalizeFirstLetter(label.labelFr);
            case 'it-CH':
                return CharCaseHelper.capitalizeFirstLetter(label.labelIt);
            default:
                return '-';
        }
    }

    resolveDate(date) {
        return date == null ? '-' : this.datePipe.transform(date.toJSDate());
    }

    resolveDateYear(date) {
        return date == null ? '-' : this.datePipe.transform(date.toJSDate(), 'yyyy');
    }
}
